// extracted by mini-css-extract-plugin
export default {"root":"tUWtYBMdZj9Djz6Sc2r8","sortable":"P1XxC4jvHa7yAq_RSpT1","sortedUp":"km4biT8mZyY3P8Nd9kcc","sortedDown":"wlw4tUe8tD8E8bqi1rww","placeHolderShimmer":"Jq7okjHBtdtb_C01HCBG"};